<template>
  <div style="margin-top: 3em" v-if="doctor">
    <div class="col-12">
      <card>
        <div class="row">
          <div class="pr-3 pl-3">
            <img :src="baseUrl + '/directtelemedicine/file/profileimage/' + doctor._id
              " v-if="doctor.profileImage" style="height: 3em; border-radius: 50%" />
            <i class="fa fa-user-md" v-if="!doctor.profileImage" style="
                background: var(--color-primary);
                padding: 10px;
                border-radius: 50%;
                color: #fff;
              "></i>
          </div>
          <div class="col-8 col-lg-11 pl-0">
            <h6 class="card-title mt-3">
              {{ $t("message.Dr") }}. {{ doctor.firstName }}
              {{ doctor.lastName }}
            </h6>
          </div>
        </div>

        <h6 class="card-subtitle mb-2 text-muted mt-3" style="font-size: smaller">
          {{ doctor.specialityText || "--" }}
        </h6>
        <p class="card-text mb-0" v-if="doctor.registration.number">
          {{ $t("message.Reg No") }}: {{ doctor.registration.number }},
          {{ doctor.registration.city }}
        </p>
        <div style="display: flex" class="mb-2" v-show="doctor.billingDetails.enabled && doctor.billingDetails.amount && slotType != 'InPerson'">
          <span>{{ $t("message.Video consultation charges") }}</span>
          <div style="color: grey; float: right; border-radius: 10%" class="pl-2">
            <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
            {{ doctor.billingDetails.amount || "--" }}
          </div>
        </div>
        <div style="display: flex" class="mb-2" v-show="doctor.billingDetails.enabled && doctor.billingDetails.inpersonAppointmentAmount && slotType == 'InPerson'">
          <span>{{ $t("message.In-Person consultation charges") }}</span>
          <div style="color: grey; float: right; border-radius: 10%" class="pl-2">
            <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
            {{ doctor.billingDetails.inpersonAppointmentAmount || "--" }}
          </div>
        </div>
        <p class="card-text" v-if="doctor && doctor.description">{{ doctor.description || "--" }}</p>
        <div class="row">
          <div class="col-lg-12" v-if="selectedLocation" style="text-align:center;">
            <n-button type="primary" style="margin-right: 10px;margin-bottom: 10px;" :simple="!hospitalSelected(location.location)" v-for="location in locations" :key="location.location.id" round @click.native="setLocationAndEndpoint(location.location, location.endpoint)" :class="hospitalSelected(location.location) ? 'custom-button-class-mobile-primary' : 'custom-button-class-mobile'">
              <i class="fas fa-hospital" style="margin-right:0.5em"></i> {{ location.location.name }}
            </n-button>
          </div>
        </div>
      </card>

      <card>
        <div class="col-12 p-0" style="border-bottom: 1px solid #0000001f">
          <div class="row">
            <div class="col-lg-12" v-if="selectedLocation && selectedLocation.name" style="text-align:center;font-weight: bold;">
              <span>{{ selectedLocation.name }}</span> <span v-if="selectedLocation.addressDetails && selectedLocation.addressDetails.address">{{ ' - ' + selectedLocation.addressDetails.address }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-2 text-center">
              <n-button type="primary" round icon @click.native="getSlotsForPreviousDay()" :disabled="days.indexOf(selectedDay) == 0">
                <i class="fa fa-chevron-left"></i>
              </n-button>
            </div>
            <div class="col-8 text-center d-flex" style="white-space: nowrap; overflow: scroll" ref="day-selector">
              <span :id="day.date.getTime()" v-for="day in days" :key="day.date.getTime()" class="ml-3 mr-3 pb-1" @click="selectDay(day)" style="line-height: 65px; cursor: pointer" :style="selectedDay == day
                ? { borderBottom: '3px solid var(--color-primary)', fontWeight: 'bold' }
                : {}
                ">{{ getDay(day) }}</span>
            </div>
            <div class="col-2 text-center">
              <n-button type="primary" round icon @click.native="getSlotsForNextDay()" :disabled="days.indexOf(selectedDay) == days.length - 1">
                <i class="fa fa-chevron-right"></i>
              </n-button>
            </div>
          </div>
        </div>
        <div class="col-sm-12" id="slots-container">
          <div style="margin-top: 1em; display: block">
            <div class="row">
              <div class="col-md-12">
                <i class="text-muted" style="font-size: smaller">Your timezone: {{ timezone }}</i>
                <div class="form-group providers-slots" style="clear: both" v-show="slots.length > 0" :id="doctor._id">
                  <div v-loading="LOADING_SLOTS">
                    <div id="slots-container" v-if="slots.length > 0" style="padding-inline-start: 0px; padding-right: 0px">
                      <!-- Morining Slots -->
                      <div class="row" style="padding-inline-start: 0px" id="morning" v-show="hasMorningSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/sun-mor.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-inline-start: 10px;
                            ">{{ $t("message.Morning") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isMorning(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>

                      <!--Afternoon Slot -->
                      <div class="row" style="margin-top: 20px; padding-inline-start: 0px" id="after" v-show="hasAfternoonSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/sun-noon.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-inline-start: 10px;
                            ">{{ $t("message.Afternoon") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isAfternoon(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 20px; padding-inline-start: 0px" v-show="hasEveningSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/sunset.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-inline-start: 10px;
                            ">{{ $t("message.Evening") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isEvening(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>
                      <div class="row" style="margin-top: 20px; padding-inline-start: 0px" v-show="hasNightSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/moon.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-inline-start: 10px;
                            ">{{ $t("message.Night") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isNight(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center" style="padding: 20px; width: 100%" v-show="slots.length < 1" v-loading="LOADING_SLOTS">
            <p class="alert-text" style="margin-bottom: 0px; font-size: x-large">
              <i>{{ $t("message.No slots available on this day") }}</i>
            </p>
          </div>
        </div>
      </card>
    </div>

    <div class="col-lg-4 offset-lg-4 pb-5" style="bottom: 0px">
      <img src="@/assets/img/booking.svg" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import momentTimezone from "moment-timezone";

export default {
  name: "slots",

  async mounted() {
    this.$store.commit("setState", {
      stateName: "selectedLocation",
      stateValue: null,
    });
    this.$store.commit("setState", {
      stateName: "selectedEndpoint",
      stateValue: null,
    });

    if (this.$route.query.type) {
      this.$store.commit("setState", {
        stateName: "slotType",
        stateValue: this.$route.query.type,
      });
    } else {
      this.$store.commit("setState", {
        stateName: "slotType",
        stateValue: "TeleConsult",
      });
    }
    if (!this.doctor) {
      if (this.$route.params.doctorId) {
        let doctor = await this.$store.dispatch(
          "getDoctor",
          this.$route.params.doctorId
        );

        this.$store.commit("setState", {
          stateName: "selectedDoctor",
          stateValue: doctor,
        });

        this.$store.commit("setState", {
          stateName: "tenant",
          stateValue: doctor.tenant.name,
        });
      } else {
        this.$router.push("/bookings");
      }
    }

    if (this.slotType == "TeleConsult") {
      if (this.endpoint.name && this.endpoint._id) {
        try {
          {
            this.$store.commit("setState", {
              stateName: "selectedEndpoint",
              stateValue: this.endpoint,
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    } else if (
      this.doctor &&
      this.doctor.endpoints &&
      this.doctor.endpoints.length > 0 &&
      this.slotType == "InPerson"
    ) {
      for (let ep of this.doctor.endpoints) {
        if (ep.endpoint && ep.endpoint.location) {
          try {
            let res = await this.$store.dispatch(
              "getLocationById",
              ep.endpoint.location
            );
            if (res && res._id) {
              this.locations.push({ location: res, endpoint: ep });
              if (!this.selectedLocation) {
                this.selectedLocation = res;
                this.$store.commit("setState", {
                  stateName: "selectedLocation",
                  stateValue: res,
                });
                this.$store.commit("setState", {
                  stateName: "selectedEndpoint",
                  stateValue: ep,
                });
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    }

    this.initDays();
    this.getSlots();

    /*     if (!this.settings) {
      let settings = await this.$store.dispatch("getPublicSettings");

      if (settings) {
        this.$store.commit("setState", {
          stateName: "settings",
          stateValue: settings,
        });
      }
    } */
    this.refreshSlots = setInterval(this.getSlots, 15000);
  },

  data() {
    return {
      slots: [],
      days: [],
      selectedDay: null,
      LOADING_SLOTS: false,
      refreshSlots: null,
      locations: [],
      selectedLocation: null,
    };
  },

  computed: {
    doctor() {
      return this.$store.state.selectedDoctor;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
    slotType() {
      return this.$store.state.slotType;
    },
    baseUrl() {
      return this.$store.state.baseUrl;
    },
    timezone() {
      return (
        momentTimezone.tz.guess() +
        " (GMT" +
        moment().tz(moment.tz.guess()).format("Z") +
        ")"
      );
    },
  },

  methods: {
    getFormattedTime(time) {
      return moment(time).format("H:mm");
    },
    setLocationAndEndpoint(location, endpoint) {
      this.selectedLocation = location;
      this.$store.commit("setState", {
        stateName: "selectedLocation",
        stateValue: location,
      });
      this.$store.commit("setState", {
        stateName: "selectedEndpoint",
        stateValue: endpoint,
      });
      this.getSlots();
    },
    getFormattedTimeForView(time) {
      return moment(time).format("h:mm A");
    },
    initDays() {
      this.days = [
        {
          date: new Date(),
          formattedDate: moment(new Date()).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 1)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 1))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 2)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 2))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 3)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 3))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 4)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 4))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 5)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 5))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 6)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 6))
          ).format("ddd, Do MMM"),
        },
      ];

      this.selectedDay = this.days[0];
    },

    hasMorningSlots() {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > -1 && hour < 12 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasAfternoonSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 11 && hour < 16 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasEveningSlots() {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 15 && hour < 20 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasNightSlots() {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 19 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },

    isMorning(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > -1 && hour < 12) {
        return true;
      } else {
        return false;
      }
    },
    isAfternoon(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 11 && hour < 16) {
        return true;
      } else {
        return false;
      }
    },
    isEvening(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 15 && hour < 20) {
        return true;
      } else {
        return false;
      }
    },
    isNight(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 19) {
        return true;
      } else {
        return false;
      }
    },

    checkForAvailibility(slot, userId) {
      var isFree = false;

      var user = slot.availability.users[userId];
      if (user.appointments == "free") {
        return "btn-success";
      } else return "d-none";
    },

    hospitalSelected(location) {
      if (
        this.selectedLocation &&
        this.selectedLocation._id &&
        location._id == this.selectedLocation._id
      ) {
        return true;
      } else {
        return false;
      }
    },

    async getSlots() {
      this.LOADING_SLOTS = true;
      let query = {
        type: "appointment",
        users: [this.doctor._id],
        tenant: this.doctor.tenant._id || this.doctor.tenant,
        dateStart: this.selectedDay.date.setHours(0, 0, 0, 0),
        dateEnd: this.selectedDay.date.setHours(23, 59, 59, 0),
        slotType:
          this.slotType == "InPerson"
            ? "Available-InPerson"
            : "Available-TeleConsult",
      };

      if (this.selectedLocation && this.selectedLocation._id) {
        query["location"] = { id: this.selectedLocation._id };
      }

      this.slots = await this.$store.dispatch("getAvailableSlots", query);
      this.LOADING_SLOTS = false;
    },
    getSlotsForNextDay() {
      if (this.days.indexOf(this.selectedDay) != this.days.length - 1) {
        this.selectedDay = this.days[this.days.indexOf(this.selectedDay) + 1];
        document
          .getElementById(this.selectedDay.date.getTime())
          .scrollIntoViewIfNeeded();
        this.getSlots();
      }
    },
    getSlotsForPreviousDay() {
      if (this.days.indexOf(this.selectedDay) != 0) {
        this.selectedDay = this.days[this.days.indexOf(this.selectedDay) - 1];
        document
          .getElementById(this.selectedDay.date.getTime())
          .scrollIntoViewIfNeeded();
        this.getSlots();
      }
    },
    getDay(day) {
      if (day.formattedDate == moment(new Date()).format("ddd, Do MMM")) {
        return "Today";
      } else {
        return day.formattedDate;
      }
    },

    selectSlot(slot) {
      this.$store.commit("setState", {
        stateName: "selectedSlot",
        stateValue: slot,
      });
      this.$router.push("/confirmbooking");
    },
    selectDay(day) {
      this.selectedDay = day;
      this.getSlots();
    },
  },
  beforeDestroy() {
    clearInterval(this.refreshSlots);
  },
};
</script>

<style scoped>
.slot-btn {
  width: 80px !important;
}

.not-available {
  cursor: no-drop;
  pointer-events: none;
}

/deep/ .el-loading-mask {
  background: #fffc !important;
  top: -15px;
}

/deep/ .el-loading-spinner {
  top: 10%;
}

/deep/ .custom-button-class-mobile {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

/deep/ .custom-button-class-mobile-primary {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}
</style>
